import { memo } from "react";
import BottomRow from "../BottomRow";
import DeviceType from "../DeviceType";
import Header from "../Header";
import MonthlyRevenue from "../Monthly Revenue";
import TopStats from "../Top Stats";
import TotalClicks from "../TotalClicks";

function Dashboard() {
    // const [visitCount, setVisitCount] = useState<any>(null);
    // const [totalStudentCurrentMonth, setTotalStudentCurrentMonth] = useState<any>(null);
    // const [totalStudentOfYear, setTotalStudentOfYear] = useState<any>(null);

    // useEffect(() => {
    //     const trackVisit = async () => {
    //         try {
    //            const res = await visitApi.countVisit();
    //            setVisitCount(res);
    //            console.log("Visit count response:", res);
    //         } catch (error) {
    //             console.error("Track visit error:", error);
    //         }
    //     };

    //     const fetchStudentStats = async () => {
    //         try {
    //             const currentMonth = await studentApi.getTotalStudentOfCurrentMonth();
    //             setTotalStudentCurrentMonth(currentMonth);
    //             console.log("Total students this month:", currentMonth);

    //             const byYear = await studentApi.getTotalStudentOfYear({ year: new Date().getFullYear() });
    //             setTotalStudentOfYear(byYear);
    //             console.log("Total students by month:", byYear);
    //         } catch (error) {
    //             console.error("Student stats error:", error);
    //         }
    //     };

    //     trackVisit();
    //     fetchStudentStats();
    // }, []);

    return (<div className="flex-1 overflow-auto h-full w-full">
        <div className="p-8">
            <Header />
            <TopStats />
            <div className="grid grid-cols-3 gap-6 mb-6">
                <MonthlyRevenue />
                <DeviceType />
                <TotalClicks />
            </div>
            <BottomRow />
        </div>
    </div>);
}

export default memo(Dashboard);